import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { TAIChatModel } from "../types/chat-ai-models"
import http from "../utils/http-common";

interface AiModelsState {
  aiModels: TAIChatModel[];
  loading: boolean;
  error: string | null;
}

const initialState: AiModelsState = {
  aiModels: [],
  loading: false,
  error: null,
};

// Async thunk to fetch models
// export const fetchModels = createAsyncThunk('models/fetchModels', async () => {
//   const response = await http.get<TAIChatModel[]>('/admin/ai-model/get-models');
//   return response.data;
// });

const aiModelsSlice = createSlice({
  name: 'aiModels',
  initialState,
  reducers: {
    setAiModels: (state, action: PayloadAction<TAIChatModel[]>) => {
      state.aiModels = action.payload;
    },
    addModel: (state, action: PayloadAction<TAIChatModel>) => {
      state.aiModels.push(action.payload);
    },
    updateModel: (state, action: PayloadAction<TAIChatModel>) => {
      const index = state.aiModels.findIndex((model) => model._id === action.payload._id);
      if (index !== -1) {
        state.aiModels[index] = action.payload;
      }
    },
    deleteModel: (state, action: PayloadAction<string>) => {
      state.aiModels = state.aiModels.filter((model) => model._id !== action.payload);
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(fetchModels.pending, (state) => {
  //       state.loading = true;
  //       state.error = null;
  //     })
  //     .addCase(fetchModels.rejected, (state, action) => {
  //       state.loading = false;
  //       state.error = action.error.message || 'Failed to fetch models';
  //     })
  //     .addCase(fetchModels.fulfilled, (state, action: PayloadAction<TAIChatModel[]>) => {
  //       state.loading = false;
  //       state.aiModels = action.payload;
  //     });
  // },
});

export const { setAiModels, addModel, updateModel, deleteModel } = aiModelsSlice.actions;

export default aiModelsSlice.reducer;